import axios from 'axios'



import { getApiKey, isTestMode } from '../../../utils'
import { ITestRaw, ITestList, IProblem, IOptions } from '../types'


const API_KEY = getApiKey()
const ENDPONT = 'thesaurus'


export const doFetchTest = async(test_id: number) => {
    try {
      const response = await axios.get(
        `/newapi/${ENDPONT}${API_KEY}/${test_id}`,
        {
          params: {},
          withCredentials: true,
        }
      )
  
      if (response) {
        const result: ITestRaw = response.data
        if (result) {
          return Promise.resolve(result)
        } else {
          console.error(`Error with /${ENDPONT}/test`)
          return Promise.reject()
        }
      }
    } catch (error) {
      if (!isTestMode) {
        console.error(error)
      }
    }
    return Promise.reject()
  }

  export const doFetchProb = async(prob_id: number) => {
    try {
      const response = await axios.get(
        `/newapi/${ENDPONT}${API_KEY}/p${prob_id}`,
        {
          params: {},
          withCredentials: true,
        }
      )
  
      if (response) {
        const result: IProblem = response.data
        if (result) {
          return Promise.resolve(result)
        } else {
          console.error(`Error with /${ENDPONT}/p`)
          return Promise.reject()
        }
      }
    } catch (error) {
      if (!isTestMode) {
        console.error(error)
      }
    }
    return Promise.reject()
  }

  interface ITestOpt {tests: ITestList, options: IOptions}

  export const doFetchList = async() => {
    try {
      const response = await axios.get(
        `/newapi/${ENDPONT}${API_KEY}`,
        {
          params: {},
          withCredentials: true,
        }
      )
      


      if (response) {
        const result: ITestOpt = {tests: response.data.tests, options: response.data.options}
        if (result) {
          return Promise.resolve(result)
        } else {
          console.error(`Error with /${ENDPONT}/test`)
          return Promise.reject()
        }
      }
    } catch (error) {
      if (!isTestMode) {
        console.error(error)
      }
    }
    return Promise.reject()
  }

  export const doPatchTestList = async(data: number[]) => {
    await axios.patch(`/newapi/${ENDPONT}${API_KEY}`, data, {
          params: {},
          withCredentials: true,
        })
    return Promise.resolve(null)
  }